export default __webpack_public_path__ + "static/media/category1.40078aae.jpg";